import React, { useState } from 'react';
import { Form, Input, Button, Typography, message } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Helmet } from 'react-helmet';
import styles from './Auth.module.css';

const { Text } = Typography;

const RegisterEmailForm = ({ onFinish, showLinks = true }) => {
  const [form] = Form.useForm();
  const [emailSent, setEmailSent] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async values => {
    setLoading(true);
    try {
      const params = new URLSearchParams(window.location.search);
      const storedParams = JSON.parse(localStorage.getItem('utmParams') || '{}');

      // URL優先、なければlocalStorageから取得（サービスページ→ウェルカム→回遊→登録の導線対応）
      const utmParams = {
        utm_source: params.get('utm_source') || storedParams.utm_source || null,
        utm_medium: params.get('utm_medium') || storedParams.utm_medium || null,
        utm_campaign: params.get('utm_campaign') || storedParams.utm_campaign || null,
        utm_content: params.get('utm_content') || storedParams.utm_content || null,
        ref: params.get('ref') || storedParams.ref || null,
        from_page: params.get('from') || storedParams.from_page || null,
        fbclid: params.get('fbclid') || storedParams.fbclid || null,
        meta_fbc: storedParams.meta_fbc || null,
        meta_fbp: storedParams.meta_fbp || null,
      };

      const data = {
        email: values.email,
        utm_params: Object.keys(utmParams).reduce((acc, key) => {
          if (utmParams[key]) acc[key] = utmParams[key];
          return acc;
        }, {}),
      };

      const success = await onFinish(data);
      if (success) {
        setEmailSent(true);
        setSubmittedEmail(values.email);
        form.resetFields();
      } else {
        setEmailSent(false);
      }
    } catch (error) {
      console.error('Error in handleSubmit:', error);
      message.error('登録に失敗しました。もう一度お試しください。');
      setEmailSent(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>新規ユーザー登録 | magicss</title>
        <meta name="robots" content="noindex" />
        <meta property="og:title" content={`新規ユーザー登録 | magicss`} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={window.location.href} />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/img/ogp.png`}
        />
        <meta
          property="og:description"
          content={`コンテンツ生成AIツール「magicss」の新規ユーザー登録ページです。`}
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      {!emailSent ? (
        <Form form={form} onFinish={handleSubmit}>
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'メールアドレスを入力してください' },
              {
                type: 'email',
                message: '有効なメールアドレスを入力してください',
              },
            ]}
            style={{ marginBottom: 16 }}
          >
            <Input
              placeholder="メールアドレス"
              size="large"
              className={styles.emailBlinkInput}
              style={{
                border: '2px solid #f5f5f5',
                backgroundColor: '#f5f5f5',
                padding: '10px 14px',
                borderRadius: 8,
                transition: 'all 0.3s',
              }}
              onFocus={e => {
                e.currentTarget.style.border = '2px solid #0072ff';
                e.currentTarget.style.backgroundColor = '#fff';
              }}
              onBlur={e => {
                e.currentTarget.style.border = '2px solid #f5f5f5';
                e.currentTarget.style.backgroundColor = '#f5f5f5';
              }}
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
              style={{
                height: 48,
                background: 'linear-gradient(90deg, #0072ff 0%, #00c6ff 100%)',
                border: 'none',
                borderRadius: 8,
                fontWeight: 600,
                fontSize: 15,
                transition: 'all 0.3s',
              }}
              onMouseEnter={e => { e.currentTarget.style.opacity = '0.85'; }}
              onMouseLeave={e => { e.currentTarget.style.opacity = '1.0'; }}
            >
              無料で始める
              <ArrowRightOutlined style={{ marginLeft: 8, fontSize: 13 }} />
            </Button>
          </Form.Item>
          <div style={{ textAlign: 'center', marginTop: 12, color: '#bbb', fontSize: 12 }}>
            認証メールからかんたん登録
          </div>
        </Form>
      ) : (
        <div style={{ textAlign: 'center', padding: '12px 0' }}>
          <div style={{ fontSize: 14, color: '#333', marginBottom: 12 }}>
            <strong>{submittedEmail}</strong> に<br />認証メールを送信しました
          </div>
          <div style={{ fontSize: 13, color: '#888', lineHeight: 1.8 }}>
            メール内のリンクをクリックして、<br />登録を完了してください。<br />
            届かない場合は迷惑メールフォルダをご確認ください。
          </div>
        </div>
      )}
    </>
  );
};

export default RegisterEmailForm;
